export const THEME_COLORS = {
  default: {
    primary: 'var(--fa-navy)',
    secondary: 'var(--fa-gravy)'
  },
  blue: {
    primary: 'var(--fa-dk-blue)',
    secondary: 'var(--fa-blue)'
  },
  yellow: {
    primary: 'var(--fa-dk-yellow)',
    secondary: 'var(--fa-yellow)'
  },
  violet: {
    primary: 'var(--fa-dk-violet)',
    secondary: 'var(--fa-violet)'
  },
  purple: {
    primary: 'var(--fa-dk-purple)',
    secondary: 'var(--fa-purple)'
  },
  red: {
    primary: 'var(--fa-dk-red)',
    secondary: 'var(--fa-red)'
  },
  teal: {
    primary: 'var(--fa-dk-teal)',
    secondary: 'var(--fa-teal)'
  }
}
